import type { FC } from "react";
import React, { Suspense } from "react";

import { BugReportModalWithNoAv } from "./BugReportModalWithNoAv";

import { useAppSelector } from "store/index";
import { selectIsClassSessionVirtual } from "store/selectors";

const BugReportModalWithAv = React.lazy(() =>
  import("./BugReportModalWithAv").then((mod) => ({ default: mod.BugReportModalWithAv })),
);

type BugReportModalProps = {
  open: boolean;
  onClose: () => void;
};

export const BugReportModal: FC<BugReportModalProps> = ({ open, onClose }) => {
  const isClassSessionVirtual = useAppSelector(selectIsClassSessionVirtual);
  if (isClassSessionVirtual) {
    return (
      <Suspense fallback={null}>
        <BugReportModalWithAv open={open} onClose={onClose} />
      </Suspense>
    );
  }
  return <BugReportModalWithNoAv open={open} onClose={onClose} />;
};
